import { App } from "vue";
import Mfm from "@/components/global/MkMisskeyFlavoredMarkdown.vue";
import MkA from "@/components/global/MkA.vue";
import MagSpinner from "@/components/global/MagSpinner.vue";
import MagButton from "@/components/global/MagButton.vue";
import MagAvatar from "@/components/global/MagAvatar.vue";
import MagEmoji from "@/components/global/MagEmoji.vue";
import MkUserName from "@/components/global/MkUserName.vue";
import MkEllipsis from "@/components/global/MkEllipsis.vue";
import MkTime from "@/components/global/MkTime.vue";
import MkUrl from "@/components/global/MkUrl.vue";
import MkLoading from "@/components/global/MkLoading.vue";
import MkError from "@/components/global/MkError.vue";
import MkPageHeader from "@/components/global/MkPageHeader.vue";
import MkSpacer from "@/components/global/MkSpacer.vue";
import MkStickyContainer from "@/components/global/MkStickyContainer.vue";
import MagAvatarResolvingProxy from "@/components/global/MagAvatarResolvingProxy.vue";
import MagTransition from "@/components/global/MagTransition.vue";

export default {
    install: (app: App) => {
        app.component("Mfm", Mfm);
        app.component("MkA", MkA);
        app.component("MagSpinner", MagSpinner);
        app.component("MagButton", MagButton);
        app.component("MagAvatar", MagAvatar);
        app.component("MagEmoji", MagEmoji);
        app.component("MkUserName", MkUserName);
        app.component("MkEllipsis", MkEllipsis);
        app.component("MkTime", MkTime);
        app.component("MkUrl", MkUrl);
        app.component("MkLoading", MkLoading);
        app.component("MkError", MkError);
        app.component("MkPageHeader", MkPageHeader);
        app.component("MkSpacer", MkSpacer);
        app.component("MkStickyContainer", MkStickyContainer);
        app.component("MagAvatarResolvingProxy", MagAvatarResolvingProxy);
        app.component("MagTransition", MagTransition);
    },
};

declare module "@vue/runtime-core" {
    interface GlobalComponents {
        Mfm: typeof Mfm;
        MkA: typeof MkA;
        MagButton: typeof MagButton;
        MagSpinner: typeof MagSpinner;
        MagAvatar: typeof MagAvatar;
        MagEmoji: typeof MagEmoji;
        MkUserName: typeof MkUserName;
        MkEllipsis: typeof MkEllipsis;
        MkTime: typeof MkTime;
        MkUrl: typeof MkUrl;
        MkLoading: typeof MkLoading;
        MkError: typeof MkError;
        MkPageHeader: typeof MkPageHeader;
        MkSpacer: typeof MkSpacer;
        MkStickyContainer: typeof MkStickyContainer;
        MagAvatarResolvingProxy: typeof MagAvatarResolvingProxy;
        MagTransition: typeof MagTransition;
    }
}
